import IconAsMaskImage from "../IconAsMaskImage";

function OutlinedMicrophone({ pureSvg, className, color }) {
  const svg = (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 20.8184V39.1343"
        stroke="black"
        strokeOpacity="1"
        strokeWidth="3.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1654 29.9766H20.832"
        stroke="black"
        strokeOpacity="1"
        strokeWidth="3.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.7143 5H18.2857C10.119 5 5 10.7802 5 18.9629V41.0371C5 49.2198 10.0952 55 18.2857 55H41.7143C49.9048 55 55 49.2198 55 41.0371V18.9629C55 10.7802 49.9048 5 41.7143 5Z"
        stroke="black"
        strokeOpacity="1"
        strokeWidth="3.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
}

export default OutlinedMicrophone;
